import { Briefcase, Search, UserPlus, Users, UserSearch } from 'lucide-react'
import { AppPaths } from '@/config/app-paths'
import type { StaffNavContext } from '../staff-nav-context'
import { group, leaf, type StaffNavGroup, type StaffNavNode } from '../nav-node'

export function buildRecruitmentGroup(ctx: StaffNavContext): StaffNavGroup | null {
  const children: StaffNavNode[] = []
  if (ctx.showJobPostsNav) {
    children.push(
      leaf('post_jobs', 'Post Jobs', AppPaths.recruitmentJobs, Briefcase, [
        'job',
        'post',
        'vacancy',
      ]),
    )
  }
  if (ctx.showApplicantsNav) {
    children.push(
      leaf('applicants', 'Applicants', AppPaths.recruitmentApplicants, Users, [
        'candidates',
        'pipeline',
      ]),
    )
  }
  if (ctx.showTalentPoolNav) {
    children.push(
      leaf('talent_pool', 'Talent Pool', AppPaths.recruitmentTalentPool, UserSearch, [
        'talent',
        'pool',
      ]),
    )
  }
  if (ctx.showWalkInNav && ctx.walkInListedUnderRecruitment) {
    children.push(
      leaf(
        'walk_in_recruitment',
        'Reception Walk-in',
        AppPaths.hrWalkInIntake,
        UserPlus,
        ['walk in', 'reception', 'intake'],
      ),
    )
  }
  if (ctx.showAdminSearch) {
    children.push(
      leaf(
        'recruitment_search',
        'Recruitment Search',
        AppPaths.adminRecruitmentSearch,
        Search,
        ['search', 'lookup'],
      ),
    )
  }
  return group(
    'recruitment',
    'Recruitment',
    Briefcase,
    ['recruitment', 'jobs', 'applicants'],
    children,
  )
}
